// removed by extract-text-webpack-plugin
module.exports = {"star-counter":"StarCounter__star-counter___1P2ki"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StarCounter/StarCounter.css
// module id = 351
// module chunks = 0